const enginePower = [
  { value: -1,  label: "Izaberi kubikažu motora"},
  { value: 1.0,  label: "1.0"},
  { value: 1.1,  label: "1.1"},
  { value: 1.2,  label: "1.2"},
  { value: 1.3,  label: "1.3"},
  { value: 1.4,  label: "1.4"},
  { value: 1.5,  label: "1.5"},
  { value: 1.6,  label: "1.6"},
  { value: 1.7,  label: "1.7"},
  { value: 1.8,  label: "1.8"},
  { value: 1.9,  label: "1.9"},
  { value: 2.0,  label: "2.0"},
  { value: 2.1,  label: "2.1"},
  { value: 2.2,  label: "2.2"},
  { value: 2.3,  label: "2.3"},
  { value: 2.4,  label: "2.4"},
  { value: 2.5,  label: "2.5"},
  { value: 2.6,  label: "2.6"},
  { value: 2.7,  label: "2.7"},
  { value: 2.8,  label: "2.8"},
  { value: 2.9,  label: "2.9"},
  { value: 3.0,  label: "3.0"},
  { value: 3.1,  label: "3.1"},
  { value: 3.2,  label: "3.2"},
  { value: 3.3,  label: "3.3"},
  { value: 3.4,  label: "3.4"},
  { value: 3.5,  label: "3.5"},
  { value: 3.6,  label: "3.6"},
];

const fuelTypes = [ 
  {value: -1, label: "Izaberi tip motora"},
  {value: 1, label: "TDI"},
  {value: 2, label: "TSI"},
  {value: 3, label: "TFSI"},
  {value: 4, label: "FSI"},
  {value: 5, label: "BiTDI"},
];

const engineTypes = [
  { value: -1, label: "Izaberi oznaku"},
  { value: 1, label: "AXZ"},
  { value: 2, label: "BWS"},
  { value: 3, label: "CAG"},
  { value: 4, label: "CAX"},
  { value: 5, label: "CAY"},
  { value: 6, label: "CBA"},
  { value: 7, label: "CBB"},
  { value: 8, label: "CBD"},
  { value: 9, label: "CCW"},
  { value: 10, label: "CDA"},
  { value: 11, label: "CDV"},
  { value: 12, label: "CEG"},
  { value: 13, label: "CFF"},
  { value: 14, label: "CFG"},
  { value: 15, label: "CFH"},
  { value: 16, label: "CFJ"},
  { value: 17, label: "CFW"},
  { value: 18, label: "CGK"},
  { value: 19, label: "CGL"},
  { value: 20, label: "CKF"},
  { value: 21, label: "CLB"},
  { value: 22, label: "CLH"},
  { value: 23, label: "CRB"},
  { value: 24, label: "CRK"},
  { value: 25, label: "CRL"},
  { value: 26, label: "CXX"},
  { value: 27, label: "DBK"},
  { value: 28, label: "DCY"},
  { value: 29, label: "DET"},
  { value: 30, label: "DEU"},
  { value: 31, label: "DFS"},  
  { value: 32, label: "CBZ"},
  { value: 33, label: "CCZ"},
  { value: 34, label: "CDN"},
  { value: 35, label: "CLAB"},
  { value: 36, label: "DDY"},
];

const transmissions = [
  { label: "Izaberi transmisiju", value: -1 },
  { label: "Automatik", value: 1 },
  { label: "Manuelni", value: 2 }
];
const bodyTypeData = [
  { value: -1, label: "Izaberi tip" },
  { value: 1, label: "Ostalo" },
  { value: 2, label: "Limuzina" },
  { value: 3, label: "Malo auto" },
  { value: 4, label: "Karavan" },
  { value: 5, label: "Monovolumen" },
  { value: 6, label: "Kombi" },
  { value: 7, label: "Terenac" },
  { value: 8, label: "SUV" },
  { value: 9, label: "Kabriolet" },
  { value: 10, label: "Sportski/kupe" },
  { value: 11, label: "Off Road" },
  { value: 12, label: "Caddy" },
  { value: 13, label: "Pick up" },
  { value: 14, label: "Oldtimer" }    
];

const paymentStatus = [
  { label: "Plaćeno?", value: -1 },
  { label: "Ne", value: 0 },
  { label: "Da", value: 1 }
];

const partStatusData = [
  { label: "Dostupno", badgeType: "success", value: 1}, 
  { label: "Nedostupno", badgeType: "danger", value: 2},
  { label: "Na čekanju", badgeType: "warning", value: 3},
  { label: "Prodano", badgeType: "primary", value: 4}
];
const categories = [
  {
    label: "Izaberi kategoriju",
    value: -1
  },
  {
    label: "ABS sistemi za automobile",
    value: 1473
  },
  {
    label: "Aditivi za automobile",
    value: 2607
  },
  {
    label: "Airbagovi za automobile",
    value: 1443
  },
  {
    label: "Akumulatori za automobile",
    value: 1446
  },
  {
    label: "Akumulatori za motocikle",
    value: 1651
  },
  {
    label: "Alarmi za automobile",
    value: 1613
  },
  {
    label: "Alat i pribor za automobile",
    value: 1615
  },
  {
    label: "Alati za bicikle",
    value: 2613
  },
  {
    label: "Alternatori za automobile",
    value: 1768
  },
  {
    label: "Alternatori za motocikle",
    value: 1694
  },
  {
    label: "Alternatori za teretna vozila",
    value: 1856
  },
  {
    label: "Amortizeri i opruge za automobile",
    value: 1462
  },
  {
    label: "Anlaseri za automobile",
    value: 1438
  },
  {
    label: "Anlaseri za motocikle",
    value: 1670
  },
  {
    label: "Anlaseri za teretna vozila",
    value: 1869
  },
  {
    label: "Antene za automobile",
    value: 2435
  },
  {
    label: "Antifrizi i permanti za automobile",
    value: 2606
  },
  {
    label: "Auto kamere",
    value: 2350
  },
  {
    label: "Auto klime",
    value: 1524
  },
  {
    label: "Autodijagnostika",
    value: 1603
  },
  {
    label: "Autofolije",
    value: 2587
  },
  {
    label: "Autokozmetika",
    value: 942
  },
  {
    label: "Automobili u dijelovima",
    value: 1523
  },
  {
    label: "Autopresvlake",
    value: 2028
  },
  {
    label: "Baglame vrata za automobile",
    value: 2483
  },
  {
    label: "Balans štange za automobile",
    value: 2439
  },
  {
    label: "Balasti za automobile",
    value: 2501
  },
  {
    label: "Bass, woofer i kutije za automobile",
    value: 1567
  },
  {
    label: "Bicikli u dijelovima",
    value: 1640
  },
  {
    label: "Biciklističke naočale",
    value: 1877
  },
  {
    label: "Birači brzina za automobile",
    value: 2472
  },
  {
    label: "Bisage/Torbe za bicikle",
    value: 1634
  },
  {
    label: "Blatobrani za automobile",
    value: 1456
  },
  {
    label: "Blatobrani za bicikle",
    value: 981
  },
  {
    label: "Blende za radio automobila",
    value: 2580
  },
  {
    label: "Board kompjuteri za automobile",
    value: 1790
  },
  {
    label: "Bobine za automobile",
    value: 1442
  },
  {
    label: "Bobine za motocikle",
    value: 1849
  },
  {
    label: "Branici i Blatobrani za teretna vozila",
    value: 969
  },
  {
    label: "Branici, karambolke i spojleri za automobile",
    value: 944
  },
  {
    label: "Brave i ključevi za automobile",
    value: 1614
  },
  {
    label: "Bregaste osovine za automobile",
    value: 1811
  },
  {
    label: "Brisači i Metlice za teretna vozila",
    value: 1872
  },
  {
    label: "Brisači za automobile",
    value: 1440
  },
  {
    label: "Brzinomjeri i Ciklokompjuteri za bicikle",
    value: 1091
  },
  {
    label: "CD/DVD/MC/Radio player za automobile",
    value: 1565
  },
  {
    label: "CD/DVD/MC/Radio player za teretna vozila",
    value: 971
  },
  {
    label: "Čepovi felgi za automobile",
    value: 2034
  },
  {
    label: "Cerade za automobile",
    value: 2462
  },
  {
    label: "Cerade za teretna vozila",
    value: 1862
  },
  {
    label: "Cijelo ozvučenje za automobile",
    value: 946
  },
  {
    label: "Cilindri za motocikle",
    value: 1664
  },
  {
    label: "Čizme za motocikliste",
    value: 1665
  },
  {
    label: "Crijeva za automobile",
    value: 2320
  },
  {
    label: "Dekla motora za automobile",
    value: 2485
  },
  {
    label: "Dekla za motocikle",
    value: 1672
  },
  {
    label: "Diferencijali za automobile",
    value: 2322
  },
  {
    label: "Diferencijali za teretna vozila",
    value: 1860
  },
  {
    label: "Dihtung za automobile",
    value: 1789
  },
  {
    label: "Dihtung za motocikle",
    value: 1701
  },
  {
    label: "Diskovi i pakne za bicikle",
    value: 1631
  },
  {
    label: "Diskovi i pločice za automobile",
    value: 1472
  },
  {
    label: "Diskovi i pločice za motocikle",
    value: 1657
  },
  {
    label: "Display/Ekran za automobile",
    value: 2451
  },
  {
    label: "Distanceri za automobile",
    value: 2452
  },
  {
    label: "Dizalice za automobile",
    value: 1486
  },
  {
    label: "Dizne za automobile",
    value: 1478
  },
  {
    label: "Doboši točka/kočioni za automobile",
    value: 2142
  },
  {
    label: "Dodaci i Pribor za motocikle",
    value: 1691
  },
  {
    label: "Duple komande za automobile",
    value: 2124
  },
  {
    label: "ECU jedinice, procesori i kompjuteri za automobile",
    value: 2491
  },
  {
    label: "Elektronika i Akustika za automobile",
    value: 1080
  },
  {
    label: "Elektronika za autobuse",
    value: 1088
  },
  {
    label: "Elektronika za građevinske mašine",
    value: 1086
  },
  {
    label: "Elektronika za motocikle",
    value: 1082
  },
  {
    label: "Elektronika za teretna vozila",
    value: 1084
  },
  {
    label: "Equalizer za automobile",
    value: 1606
  },
  {
    label: "Farovi i Štopke za autobuse",
    value: 1000
  },
  {
    label: "Farovi i Štopke za automobile",
    value: 939
  },
  {
    label: "Farovi i Štopke za građevinske mašine",
    value: 988
  },
  {
    label: "Farovi i Štopke za teretna vozila",
    value: 964
  },
  {
    label: "Felge s gumama za automobile",
    value: 1616
  },
  {
    label: "Felge za autobuse",
    value: 998
  },
  {
    label: "Felge za automobile",
    value: 937
  },
  {
    label: "Felge za bicikle",
    value: 974
  },
  {
    label: "Felge za građevinske mašine",
    value: 986
  },
  {
    label: "Felge za motocikle",
    value: 950
  },
  {
    label: "Felge za teretna vozila",
    value: 962
  },
  {
    label: "Filteri za automobile",
    value: 1434
  },
  {
    label: "Filteri za motocikle",
    value: 1646
  },
  {
    label: "Filteri za teretna vozila",
    value: 1868
  },
  {
    label: "FM transmiteri za automobile",
    value: 2401
  },
  {
    label: "Garderoba za bicikliste",
    value: 1625
  },
  {
    label: "Glavčine za automobile",
    value: 1624
  },
  {
    label: "Glave motora za automobile",
    value: 2139
  },
  {
    label: "Glave motora/cilindra za motocikle",
    value: 1654
  },
  {
    label: "Graničnici vrata za automobile",
    value: 2516
  },
  {
    label: "Grijači za automobile",
    value: 1749
  },
  {
    label: "Gume za autobuse",
    value: 1001
  },
  {
    label: "Gume za automobile",
    value: 940
  },
  {
    label: "Gume za bicikle",
    value: 977
  },
  {
    label: "Gume za građevinske mašine",
    value: 1871
  },
  {
    label: "Gume za motocikle",
    value: 953
  },
  {
    label: "Gume za teretna vozila",
    value: 965
  },
  {
    label: "Gusjenice za građevinske mašine",
    value: 1804
  },
  {
    label: "Haube za automobile",
    value: 1457
  },
  {
    label: "Hlače za motocikliste",
    value: 1667
  },
  {
    label: "Hlađenje i usis za motocikle",
    value: 1671
  },
  {
    label: "Hladnjaci i grijači za teretna vozila",
    value: 1859
  },
  {
    label: "Hladnjaci za automobile",
    value: 1469
  },
  {
    label: "Instrument table za automobile",
    value: 1451
  },
  {
    label: "Izduvni sistemi za autobuse",
    value: 1006
  },
  {
    label: "Izduvni sistemi za automobile",
    value: 945
  },
  {
    label: "Izduvni sistemi za građevinske mašine",
    value: 994
  },
  {
    label: "Izduvni sistemi za motocikle",
    value: 958
  },
  {
    label: "Izduvni sistemi za teretna vozila",
    value: 970
  },
  {
    label: "Jakne za motocikliste",
    value: 1511
  },
  {
    label: "Kabine za teretna vozila",
    value: 1851
  },
  {
    label: "Kablovi i konektori za automobile",
    value: 1599
  },
  {
    label: "Kacige za bicikliste",
    value: 1089
  },
  {
    label: "Kacige za motocikliste",
    value: 1041
  },
  {
    label: "Kamionski španeri",
    value: 1853
  },
  {
    label: "Kapice za automobilske gume",
    value: 1476
  },
  {
    label: "Karburatori za automobile",
    value: 1444
  },
  {
    label: "Karburatori za motocikle",
    value: 1666
  },
  {
    label: "Kardani za automobile",
    value: 1621
  },
  {
    label: "Kardani za teretna vozila",
    value: 1867
  },
  {
    label: "Karteri za automobile",
    value: 1766
  },
  {
    label: "Katalizatori za automobile",
    value: 1436
  },
  {
    label: "Kederi za automobile",
    value: 2393
  },
  {
    label: "Kilometar sat za motocikle",
    value: 1509
  },
  {
    label: "Kilometar satovi za automobile",
    value: 1788
  },
  {
    label: "Kinetički zglobovi za automobile",
    value: 2105
  },
  {
    label: "Kipe za teretna vozila",
    value: 1855
  },
  {
    label: "Klipovi i karike za motocikle",
    value: 1655
  },
  {
    label: "Klipovi za automobile",
    value: 2138
  },
  {
    label: "Ključevi i Brave za motocikle",
    value: 1697
  },
  {
    label: "Kočioni cilindri za automobile",
    value: 1487
  },
  {
    label: "Kočnice i kliješta za motocikle",
    value: 1696
  },
  {
    label: "Kočnice za bicikle",
    value: 1549
  },
  {
    label: "Koferi i Torbe za motocikle",
    value: 1609
  },
  {
    label: "Komplet točkovi za bicikle",
    value: 1546
  },
  {
    label: "Komplet točkovi za motocikle",
    value: 1656
  },
  {
    label: "Kompresori za automobile",
    value: 1622
  },
  {
    label: "Kondenzatori za automobile",
    value: 1604
  },
  {
    label: "Kopče, žabice i spojke za automobile",
    value: 2445
  },
  {
    label: "Korpe za bicikle",
    value: 1635
  },
  {
    label: "Kožice mjenjača za automobile",
    value: 2353
  },
  {
    label: "Krajnice za automobile",
    value: 2107
  },
  {
    label: "Kranovi za teretna vozila",
    value: 1854
  },
  {
    label: "Kućišta osigurača i osigurači za automobile",
    value: 2523
  },
  {
    label: "Kuke za automobile",
    value: 1458
  },
  {
    label: "Kvačila i Mjenjači za motocikle",
    value: 1675
  },
  {
    label: "Kvačila za automobile",
    value: 1474
  },
  {
    label: "Lafete za automobile",
    value: 1618
  },
  {
    label: "Lajsne i pragovi za automobile",
    value: 1522
  },
  {
    label: "Lamele za automobile",
    value: 1452
  },
  {
    label: "Lamele za motocikle",
    value: 1699
  },
  {
    label: "Lančanici za motocikle",
    value: 1847
  },
  {
    label: "Lanci za bicikle",
    value: 1628
  },
  {
    label: "Lanci za snijeg automobilskih guma",
    value: 1812
  },
  {
    label: "Lanci za snijeg za teretna vozila",
    value: 1813
  },
  {
    label: "Letve volana za automobile",
    value: 1471
  },
  {
    label: "Ležajevi za automobile",
    value: 1435
  },
  {
    label: "Ležajevi za motocikle",
    value: 2153
  },
  {
    label: "Limarija i Plastika za motocikle",
    value: 1081
  },
  {
    label: "Limarija i plastika za teretna vozila",
    value: 1083
  },
  {
    label: "Limarija za autobuse",
    value: 1087
  },
  {
    label: "Limarija za automobile",
    value: 1079
  },
  {
    label: "Limarija za građevinske mašine",
    value: 1085
  },
  {
    label: "Lule za bicikle",
    value: 1642
  },
  {
    label: "Maglenke za automobile",
    value: 2015
  },
  {
    label: "Magneti za motocikle",
    value: 1693
  },
  {
    label: "Makaze i držači haube za automobile",
    value: 2463
  },
  {
    label: "Manžetne za automobile",
    value: 2571
  },
  {
    label: "Mašine za motocikle",
    value: 1512
  },
  {
    label: "Maske za automobile",
    value: 1439
  },
  {
    label: "Metlice brisača za automobile",
    value: 2012
  },
  {
    label: "Mjenjači prednji/zadnji za bicikle",
    value: 1545
  },
  {
    label: "Mjenjači za automobile",
    value: 1433
  },
  {
    label: "Mjenjači za teretna vozila",
    value: 1861
  },
  {
    label: "Mjerači i šipke ulja za automobile",
    value: 2603
  },
  {
    label: "Moduli airbegova za automobile",
    value: 2644
  },
  {
    label: "Motocikli u dijelovima",
    value: 1542
  },
  {
    label: "Motodijagnostika",
    value: 1846
  },
  {
    label: "Motori šibera za automobile",
    value: 2589
  },
  {
    label: "Motori za automobile",
    value: 1061
  },
  {
    label: "Motori za čamce i brodove",
    value: 1880
  },
  {
    label: "Motori za teretna vozila",
    value: 1765
  },
  {
    label: "Motorići i klapne grijanja za automobile",
    value: 2441
  },
  {
    label: "Naljepnice i stikeri za automobile",
    value: 2455
  },
  {
    label: "Naljepnice/Stikeri za teretna vozila",
    value: 2585
  },
  {
    label: "Naočale za motocikliste",
    value: 1848
  },
  {
    label: "Naslonjači za automobile",
    value: 1460
  },
  {
    label: "Navigacija / GPS za teretna vozila",
    value: 963
  },
  {
    label: "Navigacija/GPS za automobile",
    value: 938
  },
  {
    label: "Nogare i Papučice za motocikle",
    value: 1653
  },
  {
    label: "Nogare za bicikle",
    value: 1643
  },
  {
    label: "Nosači alternatora za automobile",
    value: 2489
  },
  {
    label: "Nosači auspuha za automobile",
    value: 2624
  },
  {
    label: "Nosači blatobrana za automobile",
    value: 2623
  },
  {
    label: "Nosači farova za automobile",
    value: 2488
  },
  {
    label: "Nosači hladnjaka za automobile",
    value: 2569
  },
  {
    label: "Nosači i koferi za automobile",
    value: 1449
  },
  {
    label: "Nosači i plastike akumulatora za automobile",
    value: 2520
  },
  {
    label: "Nosači motora i mjenjača za automobile",
    value: 2128
  },
  {
    label: "Nosači osovina za automobile",
    value: 2576
  },
  {
    label: "Nosači ventilatora za automobile",
    value: 2570
  },
  {
    label: "Nosači za bicikle",
    value: 2612
  },
  {
    label: "Nosači za motocikle",
    value: 1647
  },
  {
    label: "Nosači/Grede branika za automobile",
    value: 2459
  },
  {
    label: "Odijela i majice za motocikliste",
    value: 1540
  },
  {
    label: "Okviri tablica za automobile",
    value: 2125
  },
  {
    label: "Osovine i nabe za bicikle",
    value: 1641
  },
  {
    label: "Osovine/Mostovi za automobile",
    value: 1490
  },
  {
    label: "Osovine/Mostovi za teretna vozila",
    value: 1769
  },
  {
    label: "Ostali dijelovi za autobuse",
    value: 1008
  },
  {
    label: "Ostali dijelovi za automobile",
    value: 947
  },
  {
    label: "Ostali dijelovi za čamce i brodove",
    value: 2132
  },
  {
    label: "Ostali dijelovi za građevinske mašine",
    value: 996
  },
  {
    label: "Ostalo za bicikle",
    value: 984
  },
  {
    label: "Ostalo za motocikle",
    value: 960
  },
  {
    label: "Ostalo za teretna vozila",
    value: 972
  },
  {
    label: "Pakne za automobile",
    value: 1441
  },
  {
    label: "Paljenje i Namotaji za motocikle",
    value: 1698
  },
  {
    label: "Papučice za automobile",
    value: 2425
  },
  {
    label: "Patosnice i podmetači za automobile",
    value: 1461
  },
  {
    label: "Pedale za bicikle",
    value: 1551
  },
  {
    label: "Pepeljare za automobile",
    value: 2473
  },
  {
    label: "Plastika za automobile",
    value: 1623
  },
  {
    label: "Plinski uređaji za automobile",
    value: 1759
  },
  {
    label: "Podizači stakala za automobile",
    value: 2094
  },
  {
    label: "Podmetači za točkove teretnih vozila",
    value: 1852
  },
  {
    label: "Pogon i zupčanici za bicikle",
    value: 1639
  },
  {
    label: "Pogonski lanci za motocikle",
    value: 1649
  },
  {
    label: "Pojačala za automobile",
    value: 1570
  },
  {
    label: "Pojasevi za motocikle",
    value: 1507
  },
  {
    label: "Poklopci i čepovi rezervoara za automobile",
    value: 2517
  },
  {
    label: "Poklopci/Zaštite motora za automobile",
    value: 2456
  },
  {
    label: "Pomoćni točkovi za bicikle",
    value: 2611
  },
  {
    label: "Postolja/Stenderi za motocikle",
    value: 1703
  },
  {
    label: "Posude tečnosti za automobile",
    value: 2152
  },
  {
    label: "Prekidači za automobile",
    value: 1450
  },
  {
    label: "Prenos i Zupčanici za motocikle",
    value: 1700
  },
  {
    label: "Prikolice za bicikle",
    value: 1762
  },
  {
    label: "Protokomjeri zraka za automobile",
    value: 1475
  },
  {
    label: "Pumpe za automobile",
    value: 1448
  },
  {
    label: "Pumpe za bicikle",
    value: 1644
  },
  {
    label: "Pumpe za motocikle",
    value: 1669
  },
  {
    label: "Pumpe za teretna vozila",
    value: 1857
  },
  {
    label: "Punjači za električna vozila",
    value: 2664
  },
  {
    label: "Radilice i Blokovi za motocikle",
    value: 1652
  },
  {
    label: "Radilice za automobile",
    value: 2141
  },
  {
    label: "Radio / ozvučenje za autobuse",
    value: 1007
  },
  {
    label: "Radio / ozvučenje za građevinske mašine",
    value: 995
  },
  {
    label: "Ramovi/Kosturi za bicikle",
    value: 1544
  },
  {
    label: "Ramovi/Kosturi za motocikle",
    value: 1638
  },
  {
    label: "Rampe goriva za automobile",
    value: 2437
  },
  {
    label: "Ratkape za automobile",
    value: 1454
  },
  {
    label: "Razvodnici paljenja za automobile",
    value: 2477
  },
  {
    label: "Reduktori za automobile",
    value: 2157
  },
  {
    label: "Regleri za motocikle",
    value: 1674
  },
  {
    label: "Releji za automobile",
    value: 2328
  },
  {
    label: "Remenovi za automobile",
    value: 1760
  },
  {
    label: "Remenovi za motocikle",
    value: 1668
  },
  {
    label: "Repovi za motocikle",
    value: 1659
  },
  {
    label: "Retrovizori za autobuse",
    value: 1004
  },
  {
    label: "Retrovizori za automobile",
    value: 943
  },
  {
    label: "Retrovizori za bicikle",
    value: 980
  },
  {
    label: "Retrovizori za motocikle",
    value: 956
  },
  {
    label: "Retrovizori za teretna vozila",
    value: 968
  },
  {
    label: "Rezervni točkovi za automobile",
    value: 2661
  },
  {
    label: "Rezervoari za automobile",
    value: 1479
  },
  {
    label: "Rezervoari za motocikle",
    value: 1610
  },
  {
    label: "Roletne/daske gepeka za automobile",
    value: 2453
  },
  {
    label: "Rotacije za automobile",
    value: 2605
  },
  {
    label: "Rotacije za teretna vozila",
    value: 2604
  },
  {
    label: "Ručice mjenjača za automobile",
    value: 2062
  },
  {
    label: "Ručice mjenjača za bicikle",
    value: 1547
  },
  {
    label: "Ručice/Gripovi za bicikle",
    value: 1661
  },
  {
    label: "Ručke i tegovi za motocikle",
    value: 1505
  },
  {
    label: "Ručne kočnice za automobile",
    value: 2450
  },
  {
    label: "Rukavice za bicikliste",
    value: 1090
  },
  {
    label: "Rukavice za motocikliste",
    value: 1510
  },
  {
    label: "Ruksaci/Torbe za bicikliste",
    value: 2110
  },
  {
    label: "Šajbe i prozori za autobuse",
    value: 1036
  },
  {
    label: "Šajbe i prozori za automobile",
    value: 1034
  },
  {
    label: "Šajbe i prozori za građevinske mašine",
    value: 1035
  },
  {
    label: "Šajbe i Vjetrobrani za teretna vozila",
    value: 1037
  },
  {
    label: "Sajle za automobile",
    value: 2144
  },
  {
    label: "Sajle za bicikle",
    value: 1879
  },
  {
    label: "Sajle za motocikle",
    value: 1650
  },
  {
    label: "Sanduci i Hladnjače za teretna vozila",
    value: 1863
  },
  {
    label: "Šarafi felgi za automobile",
    value: 2095
  },
  {
    label: "Senzori za automobile",
    value: 1470
  },
  {
    label: "Sigurnosni pojasevi za automobile",
    value: 2458
  },
  {
    label: "Sijalice za automobile",
    value: 1453
  },
  {
    label: "Sirene i tasteri za automobile",
    value: 2549
  },
  {
    label: "Sjedišta i sicevi za bicikle",
    value: 978
  },
  {
    label: "Sjedišta za autobuse",
    value: 1002
  },
  {
    label: "Sjedišta za automobile",
    value: 941
  },
  {
    label: "Sjedišta za građevinske mašine",
    value: 990
  },
  {
    label: "Sjedišta za motocikle",
    value: 954
  },
  {
    label: "Sjedišta za teretna vozila",
    value: 966
  },
  {
    label: "Školjke automobila",
    value: 1504
  },
  {
    label: "Skretnice za automobile",
    value: 1605
  },
  {
    label: "Snorkel za automobile",
    value: 2629
  },
  {
    label: "Španeri/Remenice za automobile",
    value: 2101
  },
  {
    label: "Spojleri i  Branici za autobuse",
    value: 1005
  },
  {
    label: "Spojleri i Branici za motocikle",
    value: 957
  },
  {
    label: "Šprice, brisači i motorići farova za automobile",
    value: 2518
  },
  {
    label: "Špule volana za automobile",
    value: 2460
  },
  {
    label: "Stabilizatori za automobile",
    value: 2321
  },
  {
    label: "Stakla i prozori za teretna vozila",
    value: 1850
  },
  {
    label: "Šticne za bicikle",
    value: 2111
  },
  {
    label: "Svjećice za automobile",
    value: 1726
  },
  {
    label: "Svjećice za motocikle",
    value: 1690
  },
  {
    label: "Svjetla tablica za automobile",
    value: 2558
  },
  {
    label: "Svjetla/Signalizacija za bicikle",
    value: 976
  },
  {
    label: "Svjetla/Signalizacija za motocikle",
    value: 952
  },
  {
    label: "Tahografi za teretna vozila",
    value: 1864
  },
  {
    label: "Tapacirung za automobile",
    value: 1619
  },
  {
    label: "Tene/Patike za bicikliste",
    value: 1632
  },
  {
    label: "Teretnjaci u dijelovima",
    value: 1873
  },
  {
    label: "Termostati za automobile",
    value: 2069
  },
  {
    label: "Torbice i pribor za bicikle",
    value: 1602
  },
  {
    label: "Tuning za automobile",
    value: 948
  },
  {
    label: "Tuning za motocikle",
    value: 961
  },
  {
    label: "Turbine za automobile",
    value: 1447
  },
  {
    label: "Turbine za čamce i brodove",
    value: 2578
  },
  {
    label: "Turbine za građevinske mašine",
    value: 2579
  },
  {
    label: "Turbine za teretna vozila",
    value: 1865
  },
  {
    label: "Uključivači za teretna vozila",
    value: 1858
  },
  {
    label: "Ulja za automobile",
    value: 1455
  },
  {
    label: "Ulje i maziva za motocikle",
    value: 1695
  },
  {
    label: "Unutrašnje osvjetljenje za automobile",
    value: 2557
  },
  {
    label: "Unutrašnji izgled za automobile",
    value: 1463
  },
  {
    label: "Upravljači/Guvernale za bicikle",
    value: 1626
  },
  {
    label: "Upravljači/Guvernale za motocikle",
    value: 1648
  },
  {
    label: "Usisne grane za automobile",
    value: 2106
  },
  {
    label: "Vakum boca za automobile",
    value: 2639
  },
  {
    label: "Vakumi turbina za automobile",
    value: 2598
  },
  {
    label: "Vandleri za automobile",
    value: 2583
  },
  {
    label: "Vanjski izgled za automobile",
    value: 1464
  },
  {
    label: "Variomati i rolnice za motocikle",
    value: 1692
  },
  {
    label: "Ventilatori za automobile",
    value: 1480
  },
  {
    label: "Ventili za automobile",
    value: 1477
  },
  {
    label: "Viljuške i amortizeri za bicikle",
    value: 1548
  },
  {
    label: "Viljuške i amortizeri za motocikle",
    value: 1508
  },
  {
    label: "Vitla za automobile",
    value: 2530
  },
  {
    label: "Vitla za teretna vozila",
    value: 1866
  },
  {
    label: "Viziri za motocikle",
    value: 1662
  },
  {
    label: "Volani za automobile",
    value: 1445
  },
  {
    label: "Vrata za automobile",
    value: 1459
  },
  {
    label: "Za autobuse i minibuse",
    value: 934
  },
  {
    label: "Za automobile",
    value: 929
  },
  {
    label: "Za bicikle",
    value: 932
  },
  {
    label: "Za građevinske mašine",
    value: 933
  },
  {
    label: "Za motocikle",
    value: 930
  },
  {
    label: "Za plovila nautiku",
    value: 935
  },
  {
    label: "Za prikolice",
    value: 949
  },
  {
    label: "Za sve ostalo",
    value: 936
  },
  {
    label: "Za teretna vozila",
    value: 931
  },
  {
    label: "Zaštita i Sigurnost za bicikle",
    value: 1627
  },
  {
    label: "Zaštita i Sigurnost za motocikle",
    value: 1658
  },
  {
    label: "Zaštita za glavu za motocikliste",
    value: 1673
  },
  {
    label: "Zaštite (sigurnosne) za automobile",
    value: 1612
  },
  {
    label: "Zaštite haube za automobile",
    value: 1751
  },
  {
    label: "Žmigavci za automobile",
    value: 1541
  },
  {
    label: "Žmigavci za motocikle",
    value: 1663
  },
  {
    label: "Žmigavci za teretna vozila",
    value: 1779
  },
  {
    label: "Znakovi za automobile",
    value: 1617
  },
  {
    label: "Zvono/Zvonce za bicikle",
    value: 1878
  },
  {
    label: "Zvučnici za automobile",
    value: 1566
  },
];

const manufacturers = [
  { value: -1, label: "Izaberi proizvođača" },
  { value: 1, label: "Audi" },
  { value: 2, label: "Škoda" },
  { value: 3, label: "Volkswagen" },
  { value: 4, label: "Seat" }
];

const models = [
  { value: -1, parentValue: -1, label: "Izaberi model"},
  { value: 30, parentValue: 1, label: "A1"}, 
  { value: 31, parentValue: 1, label: "A2"}, 
  { value: 32, parentValue: 1, label: "A3"}, 
  { value: 33, parentValue: 1, label: "A3 8P"}, 
  { value: 34, parentValue: 1, label: "A3 8V"}, 
  { value: 35, parentValue: 1, label: "A3 Allstreet"}, 
  { value: 36, parentValue: 1, label: "A4"}, 
  { value: 37, parentValue: 1, label: "A4 B8"}, 
  { value: 38, parentValue: 1, label: "A4 B8.5"}, 
  { value: 39, parentValue: 1, label: "A4 B9"}, 
  { value: 40, parentValue: 1, label: "A4 Allroad"}, 
  { value: 41, parentValue: 1, label: "A5"}, 
  { value: 42, parentValue: 1, label: "A6"}, 
  { value: 43, parentValue: 1, label: "A6 Allroad"}, 
  { value: 44, parentValue: 1, label: "A7"}, 
  { value: 45, parentValue: 1, label: "A8"}, 
  { value: 46, parentValue: 1, label: "Cabriolet"}, 
  { value: 47, parentValue: 1, label: "Coupé"}, 
  { value: 48, parentValue: 1, label: "e-tron"}, 
  { value: 49, parentValue: 1, label: "e-tron GT"}, 
  { value: 50, parentValue: 1, label: "Q4 e-tron"}, 
  { value: 51, parentValue: 1, label: "Q8 e-tron"}, 
  { value: 52, parentValue: 1, label: "Q1"}, 
  { value: 53, parentValue: 1, label: "Q2"}, 
  { value: 54, parentValue: 1, label: "Q3"}, 
  { value: 55, parentValue: 1, label: "Q5"}, 
  { value: 56, parentValue: 1, label: "Q7"}, 
  { value: 57, parentValue: 1, label: "Q8"}, 
  { value: 58, parentValue: 1, label: "QUATTRO"}, 
  { value: 59, parentValue: 1, label: "R8"}, 
  { value: 60, parentValue: 1, label: "RS2"}, 
  { value: 61, parentValue: 1, label: "RS3"}, 
  { value: 62, parentValue: 1, label: "RS4"}, 
  { value: 63, parentValue: 1, label: "RS5"}, 
  { value: 64, parentValue: 1, label: "RS6"}, 
  { value: 65, parentValue: 1, label: "RS7"}, 
  { value: 66, parentValue: 1, label: "RSQ3"}, 
  { value: 67, parentValue: 1, label: "RSQ8"}, 
  { value: 68, parentValue: 1, label: "S1"}, 
  { value: 69, parentValue: 1, label: "S2"}, 
  { value: 70, parentValue: 1, label: "S3"}, 
  { value: 71, parentValue: 1, label: "S4"}, 
  { value: 72, parentValue: 1, label: "S5"}, 
  { value: 73, parentValue: 1, label: "S6"}, 
  { value: 74, parentValue: 1, label: "S7"}, 
  { value: 75, parentValue: 1, label: "S8"}, 
  { value: 76, parentValue: 1, label: "SQ2"}, 
  { value: 77, parentValue: 1, label: "SQ5"}, 
  { value: 78, parentValue: 1, label: "SQ7"}, 
  { value: 79, parentValue: 1, label: "SQ8"}, 
  { value: 80, parentValue: 1, label: "TT"}, 
  { value: 81, parentValue: 1, label: "TT RS"}, 
  { value: 82, parentValue: 1, label: "TTS"}, 
  { value: 83, parentValue: 1, label: "V8"}, 
  { value: 84, parentValue: 1, label: "80"}, 
  { value: 85, parentValue: 1, label: "90"}, 
  { value: 86, parentValue: 1, label: "100"}, 
  { value: 87, parentValue: 1, label: "200"}, 
  { value: 88, parentValue: 1, label: "Drugi"}, 
  { value: 89, parentValue: 2, label: "105"}, 
  { value: 90, parentValue: 2, label: "120"}, 
  { value: 91, parentValue: 2, label: "130"}, 
  { value: 92, parentValue: 2, label: "135"}, 
  { value: 93, parentValue: 2, label: "Citigo"}, 
  { value: 94, parentValue: 2, label: "Enyaq"}, 
  { value: 95, parentValue: 2, label: "Enyaq Coupé"}, 
  { value: 96, parentValue: 2, label: "Fabia"}, 
  { value: 97, parentValue: 2, label: "Fabia RS"}, 
  { value: 98, parentValue: 2, label: "Favorit"}, 
  { value: 99, parentValue: 2, label: "Felicia"}, 
  { value: 100, parentValue: 2, label: "Forman"}, 
  { value: 101, parentValue: 2, label: "Kamiq"}, 
  { value: 102, parentValue: 2, label: "Karoq"}, 
  { value: 103, parentValue: 2, label: "Kodiaq"}, 
  { value: 104, parentValue: 2, label: "Octavia"}, 
  { value: 105, parentValue: 2, label: "Octavia A6"}, 
  { value: 106, parentValue: 2, label: "Octavia A7"}, 
  { value: 107, parentValue: 2, label: "Octavia A7.5"}, 
  { value: 108, parentValue: 2, label: "Octavia RS"}, 
  { value: 109, parentValue: 2, label: "Octavia Scout"}, 
  { value: 110, parentValue: 2, label: "Pick-up"}, 
  { value: 111, parentValue: 2, label: "Praktik"}, 
  { value: 112, parentValue: 2, label: "Rapid"}, 
  { value: 113, parentValue: 2, label: "Roomster"}, 
  { value: 114, parentValue: 2, label: "Scala"}, 
  { value: 115, parentValue: 2, label: "Spaceback"}, 
  { value: 116, parentValue: 2, label: "Superb"}, 
  { value: 117, parentValue: 2, label: "Yeti"}, 
  { value: 118, parentValue: 2, label: "Drugi"}, 
  { value: 119, parentValue: 3, label: "181"}, 
  { value: 120, parentValue: 3, label: "Amarok"}, 
  { value: 121, parentValue: 3, label: "Arteon"}, 
  { value: 122, parentValue: 3, label: "Atlas"}, 
  { value: 123, parentValue: 3, label: "Bora"}, 
  { value: 124, parentValue: 3, label: "Buba / Beetle"}, 
  { value: 125, parentValue: 3, label: "Buggy"}, 
  { value: 126, parentValue: 3, label: "Caddy"}, 
  { value: 127, parentValue: 3, label: "Corrado"}, 
  { value: 128, parentValue: 3, label: "Crafter"}, 
  { value: 129, parentValue: 3, label: "Eos"}, 
  { value: 130, parentValue: 3, label: "Fox"}, 
  { value: 131, parentValue: 3, label: "e-Golf"}, 
  { value: 132, parentValue: 3, label: "Golf 6"}, 
  { value: 133, parentValue: 3, label: "Golf 6 Plus"}, 
  { value: 134, parentValue: 3, label: "Golf 7"}, 
  { value: 135, parentValue: 3, label: "Golf 7.5"}, 
  { value: 136, parentValue: 3, label: "Golf Alltrack"}, 
  { value: 137, parentValue: 3, label: "Golf GTE"}, 
  { value: 138, parentValue: 3, label: "Golf Plus"}, 
  { value: 139, parentValue: 3, label: "Golf Sportsvan"}, 
  { value: 140, parentValue: 3, label: "ID.3"}, 
  { value: 141, parentValue: 3, label: "ID.3 GTX"}, 
  { value: 142, parentValue: 3, label: "ID.4"}, 
  { value: 143, parentValue: 3, label: "ID.5"}, 
  { value: 144, parentValue: 3, label: "ID.6"}, 
  { value: 145, parentValue: 3, label: "ID.7"}, 
  { value: 146, parentValue: 3, label: "ID.7 GTX Tourer"}, 
  { value: 147, parentValue: 3, label: "ID.Buzz"}, 
  { value: 148, parentValue: 3, label: "ID.Buzz Cargo"}, 
  { value: 149, parentValue: 3, label: "Iltis"}, 
  { value: 150, parentValue: 3, label: "Jetta"}, 
  { value: 151, parentValue: 3, label: "Karmann Ghia"}, 
  { value: 152, parentValue: 3, label: "LT"}, 
  { value: 153, parentValue: 3, label: "Lupo"}, 
  { value: 154, parentValue: 3, label: "Passat"}, 
  { value: 155, parentValue: 3, label: "Passat 6"}, 
  { value: 156, parentValue: 3, label: "Passat 7"}, 
  { value: 157, parentValue: 3, label: "Passat 8"}, 
  { value: 158, parentValue: 3, label: "Passat Alltrack"}, 
  { value: 159, parentValue: 3, label: "Passat CC"}, 
  { value: 160, parentValue: 3, label: "Phaeton"}, 
  { value: 161, parentValue: 3, label: "Polo"}, 
  { value: 162, parentValue: 3, label: "Polo Cross"}, 
  { value: 163, parentValue: 3, label: "Polo Plus"}, 
  { value: 164, parentValue: 3, label: "Routan"}, 
  { value: 165, parentValue: 3, label: "Santana"}, 
  { value: 166, parentValue: 3, label: "Scirocco"}, 
  { value: 167, parentValue: 3, label: "Sharan"}, 
  { value: 168, parentValue: 3, label: "T1"}, 
  { value: 169, parentValue: 3, label: "T2"}, 
  { value: 170, parentValue: 3, label: "T3 Caravelle"}, 
  { value: 171, parentValue: 3, label: "T3 Drugi"}, 
  { value: 172, parentValue: 3, label: "T3 Kombi"}, 
  { value: 173, parentValue: 3, label: "T3 Multivan"}, 
  { value: 174, parentValue: 3, label: "T4 Caravelle"}, 
  { value: 175, parentValue: 3, label: "T4 Drugi"}, 
  { value: 176, parentValue: 3, label: "T4 Kombi"}, 
  { value: 177, parentValue: 3, label: "T4 Multivan"}, 
  { value: 178, parentValue: 3, label: "T5 Caravelle"}, 
  { value: 179, parentValue: 3, label: "T5 Drugi"}, 
  { value: 180, parentValue: 3, label: "T5 Kombi"}, 
  { value: 181, parentValue: 3, label: "T5 Multivan"}, 
  { value: 182, parentValue: 3, label: "T5 Shuttle"}, 
  { value: 183, parentValue: 3, label: "T6 Caravelle"}, 
  { value: 184, parentValue: 3, label: "T6 Drugi"}, 
  { value: 185, parentValue: 3, label: "T6 Kombi"}, 
  { value: 186, parentValue: 3, label: "T6 Multivan"}, 
  { value: 187, parentValue: 3, label: "T6 Shuttle"}, 
  { value: 188, parentValue: 3, label: "T7 Multivan"}, 
  { value: 189, parentValue: 3, label: "Taigo"}, 
  { value: 190, parentValue: 3, label: "Taro"}, 
  { value: 191, parentValue: 3, label: "T-Cross"}, 
  { value: 192, parentValue: 3, label: "Tiguan"}, 
  { value: 193, parentValue: 3, label: "Tiguan Allspace"}, 
  { value: 194, parentValue: 3, label: "Touareg"}, 
  { value: 195, parentValue: 3, label: "Touran"}, 
  { value: 196, parentValue: 3, label: "T-Roc"}, 
  { value: 197, parentValue: 3, label: "T-Roc Cabriolet"}, 
  { value: 198, parentValue: 3, label: "Up!"}, 
  { value: 199, parentValue: 3, label: "Vento"}, 
  { value: 200, parentValue: 3, label: "XL1"}, 
  { value: 201, parentValue: 3, label: "Drugi"},
  { value: 202, parentValue: 4, label: "Alhambra" },
  { value: 203, parentValue: 4, label: "Altea" },
  { value: 204, parentValue: 4, label: "Altea XL" },
  { value: 205, parentValue: 4, label: "Arona" },
  { value: 206, parentValue: 4, label: "Arosa" },
  { value: 207, parentValue: 4, label: "Ateca" },
  { value: 208, parentValue: 4, label: "Cordoba" },
  { value: 209, parentValue: 4, label: "Exeo" },
  { value: 210, parentValue: 4, label: "Ibiza" },
  { value: 211, parentValue: 4, label: "Inca" },
  { value: 212, parentValue: 4, label: "Leon" },
  { value: 213, parentValue: 4, label: "Malaga" },
  { value: 214, parentValue: 4, label: "Marbella" },
  { value: 215, parentValue: 4, label: "Mii" },
  { value: 216, parentValue: 4, label: "Tarraco" },
  { value: 217, parentValue: 4, label: "Tarraco e-HYBRID" },
  { value: 218, parentValue: 4, label: "Terra" },
  { value: 219, parentValue: 4, label: "Toledo" },
  { value: 220, parentValue: 4, label: "Drugi" }
];

export {enginePower, transmissions, fuelTypes, engineTypes, manufacturers, models, partStatusData, paymentStatus, bodyTypeData, categories };